import React from 'react';
import { Typography, Icon, Input, Paper } from '@material-ui/core';

import { FuseAnimate } from '../../../../@fuse';

export default class PageHeader extends React.Component {
  state = {
    keyword: '',
  };
  handleSearchType = e => {
    this.setState({ keyword: e.target.value });
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      this.props.onSearch(this.state.keyword);
    }
  };

  render() {
    return (
      <div className="flex flex-1 flex-col w-full sm:flex-row items-center justify-between p-8 md:p-24">
        <div className="flex items-center">
          <FuseAnimate animation="transition.expandIn" delay={300}>
            <Icon className="text-32 mr-12">settings</Icon>
          </FuseAnimate>
          <FuseAnimate animation="transition.slideLeftIn" delay={300}>
            <Typography variant="title">Role Setting</Typography>
          </FuseAnimate>
        </div>

        <div className="flex flex-1 items-center justify-center px-16">
          {/* <MuiThemeProvider theme={FuseSelectedTheme}> */}
          <FuseAnimate animation="transition.slideDownIn" delay={300}>
            <Paper className="flex p-4 items-center w-full max-w-512 px-8 py-4" elevation={1}>
              <Icon className="mr-8" color="action">
                search
              </Icon>

              <Input
                onKeyPress={this.onKeyPress}
                placeholder="Search"
                className="flex flex-1"
                disableUnderline
                fullWidth
                disabled={this.props.disabled}
                value={this.state.keyword}
                onChange={this.handleSearchType}
                inputProps={{
                  'aria-label': 'Search',
                }}
              />
            </Paper>
          </FuseAnimate>
          {/* </MuiThemeProvider> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/content/project/users/PageHeader.js